import { render, staticRenderFns } from "./TopicLifecycles.vue?vue&type=template&id=08576539&"
import script from "./TopicLifecycles.vue?vue&type=script&lang=js&"
export * from "./TopicLifecycles.vue?vue&type=script&lang=js&"
import style0 from "./TopicLifecycles.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports